<template>
 <div class="new-blog">
   <div class="container-fluid">
     <sidebar />
     <div class="col-md-9 col-lg-10 ml-md-auto ">
       <div id="scroll" class="header d-flex justify-content-start w-100 align-items-center py-3 mb-5 border-bottom border-dark">
         <h2 class="my-3">新規ブログを追加</h2>
       </div>
       <div class="validation py-3 px-5 my-4" v-if="error">
          <p class="m-0">{{error}}</p>
       </div>
       <div class="new-blog-form mb-4 ">
         <b-container fluid class="p-0 ">
           <b-form>
            <div class="bg-light p-4 mb-5">

              <b-row class="my-3 align-items-center d-flex">
                <b-col lg="2">
                  <label class="m-0 font-weight-bold required">管理用タイトル</label>
                </b-col>
                <b-col lg="10">
                  <b-form-input v-model="$v.blog.administrative_title.$model" class="form-input" :state="validateState('administrative_title')"></b-form-input>
                  <b-form-invalid-feedback :state="validateState('administrative_title')">
                    <p v-if="!$v.blog.administrative_title.required">管理用タイトルは必須です</p>
                    <p v-if="!$v.blog.administrative_title.minLength">管理タイトルは{{$v.blog.administrative_title.$params.minLength.min}}文字以上入力してください</p>
                  </b-form-invalid-feedback>
                </b-col>
              </b-row>

              <b-row class="my-3 align-items-center d-flex">
                <b-col lg="2">
                  <label class="m-0 required">カテゴリ</label>
                </b-col>
                <b-col lg="4">
                  <b-form-select v-model="$v.blog.category.$model" :options="categories" class="form-select" :state="validateState('category')"></b-form-select>
                  <b-form-invalid-feedback :state="validateState('category')">
                    <p v-if="!$v.blog.category.required">カテゴリは必須です</p>
                  </b-form-invalid-feedback>
                </b-col>
              </b-row>
              <b-row class="my-3 align-items-center d-flex">
                <b-col lg="2">
                  <label class="m-0 required">アイキャッチ画像</label>
                </b-col>
                <b-col lg="10">
                  <b-form-file v-model="blog.image" accept=".jpg, .png, .gif" placeholder="ファイルを選択してください" @change="imageUpload" required :state="validateState('image')"></b-form-file>
                  <b-form-invalid-feedback :state="validateState('image')">
                    <p v-if="!$v.blog.image.required">アイキャッチ画像は必須です</p>
                  </b-form-invalid-feedback>
                </b-col>
              </b-row>
            </div>

            <div class="bg-light p-4">
              <b-form-group label="言語" id="language" class="mb-4 required">
                <b-col lg="4" class="p-0">
                  <b-form-select v-model="$v.blog.language.$model" :options="languages" class="form-select" :state="validateState('language')"></b-form-select>
                  <b-form-invalid-feedback :state="validateState('language')">
                    <p v-if="!$v.blog.language.required">言語は必須です</p>
                  </b-form-invalid-feedback>
                </b-col>
              </b-form-group>
              <b-form-group label="ブログタイトル" id="blog-title" class="mb-4 required">
                <b-col class="p-0">
                  <b-form-input v-model="$v.blog.title.$model" class="form-input" :state="validateState('title')"></b-form-input>
                  <b-form-invalid-feedback :state="validateState('title')">
                    <p v-if="!$v.blog.title.required">ブログタイトルは必須です</p>
                    <p v-if="!$v.blog.title.minLength">ブログタイトルは{{$v.blog.title.$params.minLength.min}}文字以上入力してください</p>
                  </b-form-invalid-feedback>
                </b-col>
              </b-form-group>
              <b-form-group label="ブログ本文" id="blog-body">
                <Editor v-model="blog.body" :api-key="getTinyConfig.api_key"  :init="getTinyConfig.config"/>
              </b-form-group>
            </div>
           </b-form>
        </b-container>
       </div>
       <div class="d-flex justify-content-start align-items-center mb-4">
         <a href="#scroll" class="text-decoration-none text-white" v-smooth-scroll><b-button class="py-3 px-5 mr-3" variant="primary" @click="draftBlogInput">下書きとして保存</b-button></a>
         <a href="#scroll" class="text-decoration-none text-white" v-smooth-scroll><b-button class="py-3 px-5" variant="success" @click="addBlogInput">公開</b-button></a>
       </div>
     </div>
   </div>
 </div>
</template>

<script>
import { required, minLength } from 'vuelidate/lib/validators'
import Editor from '@tinymce/tinymce-vue'
import sidebar from '@/components/_sidebar/sidebar'
import appConfig from '../../api/api'
import { mapActions } from 'vuex'
import { blogCategories } from '../../assets/data/values'

export default {
  data () {
    return {
      blog: {
        administrative_title: null,
        category: null,
        language: null,
        title: null,
        body: null,
        image: null,
        status: null
      },
      categories: [{ text: this.$i18n.t('please_choose'), disabled: true }].concat(blogCategories.map(v => { return { value: v, text: this.$i18n.t(v) } })),
      languages: [
        { value: null, text: '選択して下さい', disabled: true },
        { value: 'name_ja', text: '日本語' },
        { value: 'name_en', text: '英語' },
        { value: 'name_zh-cn', text: '簡体字' },
        { value: 'name_zh-tw', text: '繁体字' }
      ],
      error: null,
      response: null
    }
  },
  validations: {
    blog: {
      administrative_title: {
        required,
        minLength: minLength(5)
      },
      category: { required },
      title: {
        required,
        minLength: minLength(5)
      },
      language: { required },
      image: { required }
    }
  },
  computed: {
    getTinyConfig: function () {
      return appConfig
    }
  },
  methods: {
    ...mapActions('adminBlog', ['newBlog']),
    validateState (name) {
      const { $dirty, $error } = this.$v.blog[name]
      return $dirty ? !$error : null
    },
    addBlogInput: function () {
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.error = 'エラー：すべてのフィールドを確認して、再試行してください'
      } else {
        this.blog.status = 'published'
        this.newBlog(this.$v.blog.$model)
        this.error = null
      }
    },
    imageUpload (event) {
      this.image = event.target.files[0]
    },
    draftBlogInput: function () {
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.error = 'エラー：すべてのフィールドを確認して、再試行してください'
      } else {
        this.blog.status = 'draft'
        this.newBlog(this.$v.blog.$model)
        this.error = null
      }
    }
  },
  components: {
    sidebar,
    Editor
  }
}
</script>
